import { render, staticRenderFns } from "./CheckboxElement.vue?vue&type=template&id=b6a91392&scoped=true&"
import script from "./CheckboxElement.vue?vue&type=script&lang=js&"
export * from "./CheckboxElement.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxElement.vue?vue&type=style&index=0&id=b6a91392&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a91392",
  null
  
)

export default component.exports